import React, { createContext, FC, useContext } from 'react'
import { SnackbarOrigin } from '@material-ui/core'
import { AlertProps } from '@material-ui/lab/Alert'

type NotificationProps = {
  message?: string
  autoClose?: number
  vertical?: SnackbarOrigin['vertical']
  horizontal?: SnackbarOrigin['horizontal']
  type?: AlertProps['severity']
}

type NotificationContextProps = {
  notification: NotificationProps
  setNotification: (data: NotificationProps) => void
  handleError: (error: any) => void
}

// @ts-ignore
const NotificationContext = createContext<NotificationContextProps>()

const NotificationProvider: FC = ({ children }) => {
  const [notification, setNotification] = React.useState<NotificationProps>({})
  const handleError = (e: any) => {
    let errorMessage = 'Ein Fehler ist aufgetreten'
    if (e.status === 403) {
      errorMessage = 'Ein Pflichtfeld ist nicht ausgefüllt'
    } else if (e.status === 404) {
      errorMessage = 'Der Token ist nicht gültig'
    } else if (e.status === 501) {
      errorMessage = 'Das alte Passwort ist nicht korrekt'
    }
    console.log(e)
    setNotification({
      message: errorMessage,
      type: 'error'
    })
  }
  return (
    <NotificationContext.Provider
      value={{
        notification,
        setNotification,
        handleError
      }}
    >
      {children}
    </NotificationContext.Provider>
  )
}

NotificationProvider.displayName = 'NotificationProvider'

export const useNotificationContext = () =>
  useContext<NotificationContextProps>(NotificationContext)

export default NotificationProvider
